<form #form="ngForm" class="container-form with-nav-tabs" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
                <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12 container-navs">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-target="#tabPrincipal" data-toggle="tab">Principal</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabMercados" data-toggle="tab">Mercados</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabNaturezasVendas" data-toggle="tab">Naturezas de Vendas</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabLinhasProducao" data-toggle="tab">Linhas de Produção</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" data-target="#tabUsuarios" data-toggle="tab">Usuários</a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabConfiguracoes" data-toggle="tab">Configurações</a>
                </li>
            </ul>
            <div class="tab-content">
                <!-- Principal -->
                <div class="tab-pane active" id="tabPrincipal">
                    <div class="row">
                        <div class="form-group col-12 col-md-6 col-xl-3">
                            <label for="codigo" class="col-form-label">Código</label>
                            <input type="number" class="form-control" [value]="entity.codigo" name="codigo" id="codigo"
                                disabled="disabled" readonly="readonly">
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                            <input type="text" class="form-control" [(ngModel)]="entity.codigoIntegracaoErp" name="codigoIntegracaoErp" id="codigoIntegracaoErp"
                                #codigoIntegracaoErp="ngModel" maxlength="50">
                            <p class="form-text text-muted">Código da unidade de negócio no seu sistema ERP</p>                                
                        </div>                        
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="nome" class="col-form-label">Nome</label>
                            <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                                #nome="ngModel" required="required" maxlength="255" [autofocus]="true">
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.required && nome.dirty"
                                msgError="O nome é obrigatório">
                            </sgt-form-control-error>
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.maxlength"
                                msgError="O nome deve ter no máximo 255 caracteres">
                            </sgt-form-control-error>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6 col-xl-3">
                            <label for="situacao" class="col-form-label">Situação</label>
                            <select class="form-control" name="situacao" id="situacao"
                                [ngModel]="entity.situacao || ''" (ngModelChange)="entity.situacao = $event"
                                #situacao="ngModel" required="required">
                                <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                            </select>
                            <sgt-form-control-error
                                *ngIf="situacao.errors && situacao.errors.required && situacao.dirty"
                                msgError="A situação é obrigatória">
                            </sgt-form-control-error>
                        </div>
                    </div>
                    
                    <!-- Configurações -->
                    <sgt-info-group title="Configurações"></sgt-info-group>
                    <div class="row">
                        <div class="form-group col-12 col-md-4">
                            <label for="lancamento" class="col-form-label">Lançamento Por</label>
                            <select class="form-control" name="lancamento" id="lancamento"
                                [ngModel]="entity.lancamento || ''" (ngModelChange)="entity.lancamento = $event"
                                #lancamento="ngModel" required="required">
                                <option *ngFor="let lancamento of lancamentos" [ngValue]="lancamento.id">{{lancamento.nome}}</option>
                            </select>
                            <sgt-form-control-error
                                *ngIf="lancamento.errors && lancamento.errors.required && lancamento.dirty"
                                msgError="A opção de lançamento é obrigatória">
                            </sgt-form-control-error>
                        </div>                        
                        <div class="form-group col-12 col-md-4">
                            <label for="unidade" class="col-form-label">Unidade de Medida</label>
                            <select class="form-control" name="unidade" id="unidade"
                                [ngModel]="entity.idItemUnidade || ''" (ngModelChange)="entity.idItemUnidade = $event ? $event : null"
                                #unidade="ngModel" required="required">
                                <option value="">Selecione a unidade...</option>
                                <option *ngFor="let unidade of unidades" [ngValue]="unidade.id">{{unidade.codigoIntegracaoErp}}</option>
                            </select>
                            <sgt-form-control-error
                                *ngIf="unidade.errors && unidade.errors.required && unidade.dirty"
                                msgError="A unidade é obrigatória">
                            </sgt-form-control-error>                            
                        </div> 
                        <div class="form-group col-12 col-md">
                            <label for="referenciaQuantidade" class="col-form-label">Referência da Quantidade na Nota Fiscal</label>
                            <select class="form-control" name="referenciaQuantidade" id="referenciaQuantidade"
                                [ngModel]="entity.referenciaQuantidade || ''" (ngModelChange)="entity.referenciaQuantidade = $event"
                                #referenciaQuantidade="ngModel" required="required">
                                <option *ngFor="let referenciaQuantidade of referenciasQuantidades" [ngValue]="referenciaQuantidade.id">{{referenciaQuantidade.nome}}</option>
                            </select>
                            <p class="form-text text-muted">Informe qual campo da nota fiscal é utilizado como referência de quantidade para esta unidade de negócio</p>

                            <sgt-form-control-error
                                *ngIf="referenciaQuantidade.errors && referenciaQuantidade.errors.required && referenciaQuantidade.dirty"
                                msgError="A referência da quantidade é obrigatória">
                            </sgt-form-control-error>
                        </div>                                               
                    </div>                    
                </div>

                <!-- Mercado -->
                <div class="tab-pane" id="tabMercados">
                    <sgt-unidade-negocio-mercado
                        [entities]="entity.mercados"
                        #unidadeNegocioMercadoForm>
                    </sgt-unidade-negocio-mercado>
                </div>

                <!-- Naturezas de Vendas -->
                <div class="tab-pane" id="tabNaturezasVendas">
                    <sgt-unidade-negocio-natureza-venda
                        [entities]="entity.naturezasVendas"
                        #unidadeNegocioNaturezaVendaForm>
                    </sgt-unidade-negocio-natureza-venda>
                </div>

                <!-- Linhas de Produção -->
                <div class="tab-pane" id="tabLinhasProducao">
                    <sgt-unidade-negocio-linha-producao
                        [canEdit]="false"
                        [nomeUnidadeNegocio]="entity.nome"
                        [entities]="entity.linhasProducao"
                        #unidadeNegocioLinhaProducaoForm>
                    </sgt-unidade-negocio-linha-producao>
                </div>                

                <!-- Usuários -->
                <!-- <div class="tab-pane" id="tabUsuarios">
                    <sgt-unidade-negocio-usuario
                        [nomeUnidadeNegocio]="entity.nome"
                        [entities]="entity.usuarios"
                        #unidadeNegocioUsuario>
                    </sgt-unidade-negocio-usuario>
                </div> -->

                <!-- Configurações -->
                <div class="tab-pane" id="tabConfiguracoes">
                    <sgt-unidade-negocio-configuracao-pedido-form
                        [(habilitarComprimentosItensPedidos)]="entity.habilitarComprimentosItensPedidos">
                    </sgt-unidade-negocio-configuracao-pedido-form>
                </div>                
            </div>
        </div>
    </div>
</form>
